import { useEffect, useState } from "react";
import ModalCadastro from "../components/modal-cadastro/ModalCadastro";
import ComoFuncionaBlockVD from "../components/versao-d/comoFuncionaBlockVD";
import FaqBlockVD from "../components/versao-d/faqBlockVD";
import FirstBlockVD from "../components/versao-d/firstBlockVD";
// import FloatingWhatsAppVD from "../components/versao-d/FloatingWhatsAppVD";
import FooterVariacaoVD from "../components/versao-d/FooterVariacaoVD";
import HeaderVD from "../components/versao-d/HeaderVD";
import RegisterBlockVD from "../components/versao-d/registerBlockVD";
import RzkBlockVD from "../components/versao-d/rzkBlockVD";
import SimuladorVD from "../components/versao-d/SimuladorVD";

const TesteD = () => {
  const [, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="overflow-hidden">
      <ModalCadastro open={false} />
      <HeaderVD />
      <FirstBlockVD />
      <SimuladorVD />
      <ComoFuncionaBlockVD />
      <RzkBlockVD />
      <RegisterBlockVD />

      <FaqBlockVD />
      {/* <FloatingWhatsAppVD /> */}
      <FooterVariacaoVD />
    </div>
  );
};

export default TesteD;
